module.exports = __webpack_public_path__ + "img/cbqq.3ba96e63.png";